import { PText } from "@porsche-design-system/components-react"
import { FullServiceHistoryOptions } from "@slfinrtl/ui-bff-routes"
import { FormattedMessage } from "react-intl"
import { emptyPlaceholder } from "src/common/emptyPlaceholder"
import { commonMessages } from "src/common/messages/common.messages"
import type { InventoryInformationFormValues } from "src/components"
import {
	conditionAndServiceFieldMessages,
	conditionFieldNames,
	DatepickerField,
	useConditionAndServiceFields,
} from "src/components"
import { FieldWrapper } from "../FieldWrapper"
import type { ConditionAndServiceChangeView } from "../conditionAndServiceChanges/ConditionAndServiceChanges"

interface ConditionChangeFormProps {
	changes?: ConditionAndServiceChangeView
	isElectric: boolean
	modelYear: number | undefined
	values: InventoryInformationFormValues
}

export const ConditionChangeForm = ({ changes, isElectric, modelYear, values }: ConditionChangeFormProps) => {
	const fields = useConditionAndServiceFields(false, modelYear, isElectric)

	return (
		<>
			{conditionFieldNames.firstRegistrationDateName in values &&
				fields.firstRegistrationDate &&
				(fields.firstRegistrationDate.disabledHint ? (
					<FieldWrapper>
						<PText>
							<FormattedMessage {...conditionAndServiceFieldMessages.firstRegistrationDateLabel} />
						</PText>
						<PText>{values.firstRegistrationDate ?? emptyPlaceholder}</PText>
					</FieldWrapper>
				) : (
					<FieldWrapper>
						<DatepickerField
							data-testid="condition-change-form_first-registration-date"
							{...fields.firstRegistrationDate}
							{...{ style: { width: "50%" } }}
						/>
					</FieldWrapper>
				))}
			{changes &&
				conditionFieldNames.fullServiceHistoryName in changes &&
				conditionFieldNames.fullServiceHistoryName in values &&
				fields.fullServiceHistory && (
					<FieldWrapper>
						<PText>
							<FormattedMessage {...conditionAndServiceFieldMessages.fullServiceHistoryLabel} />
						</PText>
						<YesOrNo value={values.fullServiceHistory === FullServiceHistoryOptions.COMPLETE} />
					</FieldWrapper>
				)}
			{changes &&
				conditionFieldNames.nonSmokerName in changes &&
				conditionFieldNames.nonSmokerName in values &&
				fields.nonSmoker && (
					<FieldWrapper>
						<PText>
							<FormattedMessage {...conditionAndServiceFieldMessages.nonSmokerLabel} />
						</PText>
						<YesOrNo value={values.nonSmoker} />
					</FieldWrapper>
				)}
			{changes &&
				conditionFieldNames.formerRentalCarName in changes &&
				conditionFieldNames.formerRentalCarName in values &&
				fields.formerRentalCar && (
					<FieldWrapper>
						<PText>
							<FormattedMessage {...conditionAndServiceFieldMessages.formerRentalCarLabel} />
						</PText>
						<YesOrNo value={values.formerRentalCar} />
					</FieldWrapper>
				)}
			{changes &&
				conditionFieldNames.accidentFreeName in changes &&
				conditionFieldNames.accidentFreeName in values &&
				fields.accidentFree && (
					<FieldWrapper>
						<PText>
							<FormattedMessage {...conditionAndServiceFieldMessages.accidentFreeLabel} />
						</PText>
						<YesOrNo value={!!values.accidentFree} />
					</FieldWrapper>
				)}
			{changes &&
				conditionFieldNames.previousDamageName in changes &&
				conditionFieldNames.previousDamageName in values &&
				fields.previousDamage && (
					<FieldWrapper>
						<PText>
							<FormattedMessage {...conditionAndServiceFieldMessages.previousDamageLabel} />
						</PText>
						<YesOrNo value={values.previousDamage} />
					</FieldWrapper>
				)}
		</>
	)
}

const YesOrNo = ({ value }: { value: boolean }) => (
	<PText>
		<FormattedMessage {...(value ? commonMessages.yes : commonMessages.no)} />
	</PText>
)
